import { render, staticRenderFns } from "./ClientSelector.vue?vue&type=template&id=66c41e30&scoped=true&"
import script from "./ClientSelector.vue?vue&type=script&lang=js&"
export * from "./ClientSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c41e30",
  null
  
)

export default component.exports